export const useIntercom = () => {
  const intercomLauncher = document.querySelector(
    ".intercom-lightweight-app-launcher"
  );
  const intercom = document.querySelector(".intercom-lightweight-app");
  const hideIntercom = () => {
    intercom?.classList.add("hide");
  };

  const showIntercom = () => {
    intercom?.classList.remove("hide");
  };

  const shiftIntercom = () => {
    intercomLauncher?.classList.add("shift");
  };

  const unshiftIntercom = () => {
    intercomLauncher?.classList.remove("shift");
  };

  return { hideIntercom, showIntercom, shiftIntercom, unshiftIntercom };
};
